(function() {
    "use strict";
    var browser = (function(ua) {
        return {
            version: (ua.match(/.+(?:me|ox|on|rv|it|era|opr|ie)[\/: ]([0-9\.]+)/) || [, '0'])[1],
            opera: (/ope?ra?/i.test(ua)),
            msie: (/msie/i.test(ua) && !/opera/i.test(ua) || /trident\//i.test(ua)),
            mozilla: /firefox/i.test(ua),
            chrome: /chrome/i.test(ua),
            safari: (!(/chrome/i.test(ua)) && /webkit|safari|khtml/i.test(ua)),
            iphone: /iphone/i.test(ua),
            ipod: /ipod/i.test(ua),
            iphone4: /iphone.*OS 4/i.test(ua),
            ipod4: /ipod.*OS 4/i.test(ua),
            ipad: /ipad/i.test(ua),
            android: /android/i.test(ua),
            mobile: /iphone|ipod|ipad|opera mini|opera mobi|iemobile|android/i.test(ua),
            msie_mobile: /iemobile/i.test(ua),
            safari_mobile: /iphone|ipod|ipad/i.test(ua),
            opera_mobile: /opera mini|opera mobi/i.test(ua),
            opera_mini: /opera mini/i.test(ua),
            minimal: {
                opera: 15,
                msie: 11,
                mozilla: 29
            }
        };
    })(navigator.userAgent.toLowerCase());
    window.bbwBrowser = function() {
        return browser;
    };

    function getType() {
        var keys = [];
        for (var key in browser) {
            if (browser.hasOwnProperty(key) && browser[key] && ['version', 'minimal'].indexOf(key) == -1) {
                keys.push(key);
            }
        }
        if (!keys.length) {
            return undefined;
        }
        return keys.join('-');
    }

    function detectUnsupportedBrowser() {
        for (var key in browser.minimal) {
            if (browser.minimal.hasOwnProperty(key) && browser[key] && parseFloat(browser.version) < browser.minimal[key]) {
                return getType();
            }
        }
        if (!window.WebSocket) {
            return getType();
        }
        var flexVariants = 'flex mozFlex oFlex msFlex webkitFlex'.split(' ');
        for (var i = 0; i < flexVariants.length; ++i) {
            if (typeof document.body.style[flexVariants[i]] !== 'undefined') {
                return undefined;
            }
        }
        return getType();
    }

    var unsupportedBrowserType = detectUnsupportedBrowser();

    if (unsupportedBrowserType 
        && 'chrome-android-mobile' !== unsupportedBrowserType // google
    ) {
        var location = '/error/old-browser.html?' + unsupportedBrowserType;
        document.body.innerHTML += '<iframe frameborder="0" style="width:100%;height:100%;position:fixed;z-index:9999999;top:0;left:0;bottom:0;right:0" src="' + location + '"></iframe>';
    }
})();
